/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q5Inputs */

const en_to_xml_faq_q5 = /** @type {(inputs: To_Xml_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the converter support XML attributes?`)
};

const ko_to_xml_faq_q5 = /** @type {(inputs: To_Xml_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML 속성(attribute)을 지원하나요?`)
};

const ja_to_xml_faq_q5 = /** @type {(inputs: To_Xml_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML属性(attribute)をサポートしていますか？`)
};

/**
* | output |
* | --- |
* | "Does the converter support XML attributes?" |
*
* @param {To_Xml_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q5 = /** @type {((inputs?: To_Xml_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q5(inputs)
	if (locale === "ko") return ko_to_xml_faq_q5(inputs)
	return ja_to_xml_faq_q5(inputs)
});